// extracted by mini-css-extract-plugin
module.exports = {"root":"LastMatch_root__3d7sJ","content":"LastMatch_content__YxPGc","infoText":"LastMatch_infoText__PbMNE"};